<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div class="relative">

        <div class="vx-navbar-wrapper" :class="classObj">

            <vs-navbar class="vx-navbar navbar-custom navbar-skelton" :color="navbarColorLocal" :class="textColor">

                <!-- SM - OPEN SIDEBAR BUTTON -->
                <feather-icon class="sm:inline-flex xl:hidden cursor-pointer p-2" icon="MenuIcon"
                              @click.stop="showSidebar"/>

                <vs-spacer/>

                <server-drop-down v-if="servers"/>
                <i18n/>
                <div class="flex" v-if="startUser.name">
                    <div class="mr-4">
                        <vs-button @click="authologinGoStartUser" radius color="primary" type="flat" v-bind="$iconData('icon-log-in', 'fi-rr-enter')"></vs-button>
                    </div>
                    <profile-drop-down
                        class="mr-4"
                        :name="startUser.name"
                        :role="startUser.roles.name"
                        :photoURL="startUser.photoURL"
                    />
                </div>

                <profile-drop-down
                    v-if="activeUserInfo.name"
                    :name="activeUserInfo.name"
                    :role="activeUserInfo.roles.name"
                    :photoURL="activeUserInfo.photoURL"
                    :menu="true"
                    :logout="true"
                    @logoutAction="logout"
                    @changeUser="changeUser"
                ></profile-drop-down>
            </vs-navbar>
        </div>
    </div>
</template>


<script>
import I18n from './components/I18n.vue'
import Bookmarks from './components/Bookmarks.vue'
import SearchBar from './components/SearchBar.vue'
import NotificationDropDown from './components/NotificationDropDown.vue'
import ProfileDropDown from './components/ProfileDropDown.vue'
import ServerDropDown from "@/layouts/components/navbar/components/ServerDropDown.vue"

export default {
    name: 'the-navbar-vertical',
    props: {
        navbarColor: {
            type: String,
            default: '#fff'
        }
    },
    components: {
        Bookmarks,
        SearchBar,
        NotificationDropDown,
        ProfileDropDown,
        I18n,
        ServerDropDown
    },

    computed: {
        servers() {
            return (JSON.parse(process.env.VUE_APP_API_SERVERS) || []).length
        },
        startUser() {
            return this.$store.getters.aUser
        },
        activeUserInfo() {
            return this.$store.state.AppActiveUser
        },

        navbarColorLocal() {
            return this.$store.state.theme === 'dark' && this.navbarColor === '#fff' ? '#10163a' : this.navbarColor
        },
        verticalNavMenuWidth() {
            return this.$store.state.verticalNavMenuWidth
        },
        textColor() {
            return {'text-white': (this.navbarColor !== '#10163a' && this.$store.state.theme === 'dark') || (this.navbarColor !== '#fff' && this.$store.state.theme !== 'dark')}
        },
        windowWidth() {
            return this.$store.state.windowWidth
        },

        // NAVBAR STYLE
        classObj() {
            if (this.verticalNavMenuWidth === 'default') return 'navbar-default'
            else if (this.verticalNavMenuWidth === 'reduced') return 'navbar-reduced'
            else if (this.verticalNavMenuWidth) return 'navbar-full'
        }
    },
    methods: {
        async changeUser(user) {
            await this.$store.dispatch('authAutologinLinkedUser', user)
        },

        showSidebar() {
            this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
        },

        async authologinGoStartUser() {
            await this.$store.dispatch('autologinGoStartUser')
        },

        disconnect() {

        },

        async logout() {
            try {
                await this.$store.dispatch('autologinGoStartUser')
                await this.$store.dispatch('LOGOUT')
            } catch (e) {
            }
        }
    }
}
</script>
